module.exports = __webpack_public_path__ + "img/no-reward.aa4636b7.png";